<template>
  <div class="teacher-login-page">
    <div class="login-admin-title">
      <mt-header title="登录">
        <router-link to="/" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
      </mt-header>
    </div>
    <div class="login-school-admin">
      <div class="login-school-admin-content">
        <div class="login-school-show">
          <div class="login-school-img-box">
            <img src="../../assets/images/login-sinlg.png" alt="">
          </div>
          <div class="login-school-name">{{ schoolName ? schoolName : '' }}</div>
          <div class="login-identity-text">学生登录</div>
        </div>
        <!-- 登录模块 -->
        <div>
          <mt-navbar v-model="selectedType">
            <mt-tab-item id="1"> <span @click="pswLogin">账号密码登录</span> </mt-tab-item>
            <mt-tab-item id="2"> <span @click="PhLogin">验证码登录</span> </mt-tab-item>
          </mt-navbar>

          <mt-tab-container v-model="selectedType">

            <mt-tab-container-item id="1">
              <mt-field placeholder="请输入用户名" v-model="username"></mt-field>
              <mt-field placeholder="请输入密码" :type="isShowPassword ? 'password' : 'text'" v-model="password"
                disableClear>
                <img v-if="!isEye" src="../../assets/images/open-eye.png" alt="" @click="closePassword">
                <img v-else src="../../assets/images/close-eye.png" alt="" @click="openPassword">
              </mt-field>
              <div class="login-tip">
                <div class="rememberPassword">
                  <mt-checklist v-model="rememberPassword" :options="options" @change="checkon"> </mt-checklist>
                </div>
                <a class="find-pws" @click="openForgetPassword()">忘记密码</a>
              </div>
            </mt-tab-container-item>

            <mt-tab-container-item id="2">
              <mt-field placeholder="请输入手机号" v-model="phone"></mt-field>
              <mt-field placeholder="请输入验证码" v-model="verifyCode">
                <span class="get-code" @click="checkPhone(phone)" :style="time < 60 && time > 0 ? 'color:#999' : ''">
                  {{ valiText }}
                </span>
              </mt-field>
            </mt-tab-container-item>
          </mt-tab-container>
          <mt-button :disabled="btnClick" class="btn1" type="primary" @click="accountSubmit">确定</mt-button>
        </div>

      </div>
    </div>

    <!-- 忘记密码 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001;" v-show="forgetPasswordModel">
      <!-- 学生 -->
      <div class="mint-msgbox" v-show="loginRole == 1" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">找回密码</div>
        </div>
        <div class="mint-msgbox-content">
          <div class="mint-msgbox-input" style="padding-top:5px;">
            <input type="text" name="phone" placeholder="请输入绑定手机号码" v-model="newMobile">
          </div>
          <div class="mint-msgbox-input" style="padding-top:5px;">
            <input type="text" name="verifyCode" placeholder="请输入验证码" class="yzm" v-model="securityCode">
            <button type="default" size="normal" class="btn" @click="checkPhone(newMobile)"
              :style="time < 60 && time > 0 ? 'background-color:#999' : ''">
              {{ valiText }}
            </button>
          </div>
          <div style="color:red;font-size: 13px;">{{ errorText }}</div>
        </div>
        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel" @click="closeForgetPassword">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm" @click="nextForgetPassword">下一步</button>
        </div>
      </div>
    </div>

    <!-- 找回密码-学生 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001;" v-show="passwordModel">
      <div class="mint-msgbox" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">找回密码</div>
        </div>
        <div class="mint-msgbox-content">
          <div class="mint-msgbox-input" style="padding-top:5px">
            <input type="password" name="password" placeholder="输入新密码" v-model="newPassword">
          </div>
          <div class="mint-msgbox-input">
            <input type="password" name="password" placeholder="确认新密码" v-model="oldPassword">
          </div>
          <div style="color:red;font-size: 13px;padding-top:5px">{{ errorText }}</div>
        </div>
        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel " @click="closeUpdatePhonePwd">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm " @click="updatePhonePwd(newMobile)">下一步</button>
        </div>
      </div>
    </div>

    <!-- 绑定手机号码 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001;" v-show="bindingPhoneModel">
      <!-- 学生 -->
      <div class="mint-msgbox" v-show="loginRole == 1" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">学生绑定手机号码</div>
        </div>
        <div class="mint-msgbox-content">
          <div style="padding: 0 10px;text-align: center;color: darkgray;" id="module1">
            <p>学生绑定手机号码请先登录微校园，然后在个人中心绑定</p>
          </div>
        </div>

        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-confirm" @click="closeBindingPhoneModel">知道了</button>
        </div>
      </div>
    </div>
    <div class="v-modal" style="z-index: 2000;" v-show="forgetPasswordModel || passwordModel || bindingPhoneModel">
    </div>
  </div>
</template>
<style>
input.yzm {
  margin-right: 10px;
}
</style>
<script>
import Vue from 'vue';
import { Header, Navbar, TabItem, Field, Toast, Checklist, Button, MessageBox } from 'mint-ui';
Vue.component(Header.name, Header);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Field.name, Field);
Vue.component(Button.name, Button);
Vue.component(Checklist.name, Checklist);
// const ip = require('ip');
// const IP = ip.address();
export default {
  data() {
    return {
      isEye: true,
      isShowPassword: true,
      schoolName: '',
      time: 60,
      username: '',
      password: '',
      selectedType: '1',
      loginRole: '1',
      phone: '',
      verifyCode: '',
      btnClick: true,
      rememberPassword: [],
      options: [{
        label: "记住密码",
        value: '1',
      }],
      valiText: '获取验证码',
      classText: 'u-btn ft-btn1',
      forgetPasswordModel: false,
      errorText: "没有绑定手机号码的学生请联系教师或管理员！",
      newMobile: null,
      securityCode: null,
      passwordModel: false,
      oldPassword: null,
      newPassword: null,
      bindingPhoneModel: false,
    }
  },
  watch: {
    "username": function () {
      this.btnClick = this.username && this.password ? false : true;
      this.classText = this.username && this.password ? 'bind' : 'ft-btn1';
    },
    "password": function () {
      this.btnClick = this.username && this.password ? false : true;
      this.classText = this.username && this.password ? 'bind' : 'ft-btn1';
    },
    "phone": function () {
      this.btnClick = this.phone && this.verifyCode ? false : true;
      this.classText = this.phone && this.verifyCode ? 'bind' : 'ft-btn1';
    },
    "verifyCode": function () {
      this.btnClick = this.phone && this.verifyCode ? false : true;
      this.classText = this.phone && this.verifyCode ? 'bind' : 'ft-btn1';
    },

  },

  //   created() {

  // try {
  //   if (_.isEmpty(account_info) || !account_info || account_info.checked != 1) return false;
  //   this.rememberPassword[0] = "1";
  //   console.log(account_info, 'account_info');
  // } catch (error) {
  //   console.log(error);
  // }
  //   },
  mounted() {
    this.schoolName = this.$route.query.schoolName;
    this.schoolId = this.$route.query.schoolId;
    if (!this.schoolName || !this.schoolId) {
      this.$router.replace({ name: 'Login' });
      return
    }

    try {
      var num = parseInt(localStorage.getItem("rememberPassword"))
      if (num == 1) {
        this.rememberPassword = [num]
      }
      let account_info = JSON.parse(localStorage.getItem("loginPws"));
      if (this.rememberPassword[0] == 1 || this.rememberPassword[0] == '1') {
        this.password = account_info.password;
        this.username = account_info.userName;
        this.btnClick = false
      }
    } catch(err) {


    }
    
  },
  methods: {
    checkon(val) {
      console.log(val);
      if (val[0] == 1) {
        localStorage.removeItem("rememberPassword")
        localStorage.setItem("rememberPassword", 1)
      } else {
        localStorage.removeItem("rememberPassword")
        localStorage.removeItem("loginPws")
        localStorage.setItem("rememberPassword", 0)
      }

    },
    PhLogin() {
      this.btnClick = true
      this.phone = '';
      this.verifyCode = '';
    },
    pswLogin() {
      if (this.username && this.password) {
        this.btnClick = false
      }
      //   this.username = '';
      //   this.password = '';
    },
    // 查看密码
    openPassword() {
      this.isEye = false
      this.isShowPassword = false
    },
    // 关闭密码
    closePassword() {
      this.isEye = true
      this.isShowPassword = true
    },
    accountSubmit() {
      if (this.selectedType == "1") {
        this.passWordLogin()
      } else {
        this.phoneLogin()
      }
      localStorage.removeItem("loginCount");
      localStorage.setItem('loginRole', this.loginRole)
    },
    passWordLogin() {
      let loginPws = {
        password: this.password,
        userName: this.username,
      }
      this.$http.post('/api/mobile/user/loginbind', {
        // ipAddress: encodeURI(IP),
        loginType: 'wechat',
        password: this.password,
        userName: this.username,
        wechat: '',
        loginRole: this.loginRole
      }).then(res => {
        if (res.data.code != 0) {
          MessageBox({
            title: '提示',
            message: res.data.message,
            showCancelButton: false
          });
        } else {
          // let account_info = { userName: this.username, password: this.password }
          // if (this.rememberPassword[0] == '1') {
          //     account_info.checked = 1;
          // } else {
          //     delete account_info['checked'];
          // }
          // localStorage.setItem("account_info", JSON.stringify(account_info));
          this.$router.replace({ name: 'Home' });
          let remPassword = localStorage.getItem("rememberPassword")
          if (remPassword == 1 || remPassword == '1') {
            this.rememberPassword = []
            localStorage.setItem("loginPws", JSON.stringify(loginPws))
          }
        }
      });
    },

    //手机验证码登录
    phoneLogin() {
      var data = {
        mobile: this.phone,
        verifyCode: this.verifyCode,
        loginRole: this.loginRole
      }
      this.$http.post('/api/mobile/user/verifyLogin', data, 'json').then(res => {
        if (res.data.code == 0) {
          this.$router.replace({ name: 'Home' });
        } else {
          MessageBox.alert(res.data.message, res.data.title);
        }
      })
    },
    // 获取验证码
    sendVerifyCode(phone) {
      this.$http.post('/api/mobile/user/sendVerifyCode', { phone: phone, loginRole: this.loginRole, schoolId: this.schoolId }).then(res => {
        if (res.data.code == 0 || res.data.code == "0") {
          this.getTerm()
          MessageBox.alert(res.data.message, "提示");
        } else {
          MessageBox.alert(res.data.message, "提示");
          // this.errorText = res.data.message;
        }
      })
    },
    //手机号验证
    checkPhone(phone) {
      if (this.time == 60) {
        let message = '';
        let title = '手机号码错误';
        if (phone == null || phone == '') {
          message = "请输入绑定的手机号码"
          MessageBox.alert(message, title);
        } else {
          this.sendVerifyCode(phone)
        }
      }
    },
    getTerm() {
      if (this.time == 60) {
        let timer = setInterval(() => {
          if (this.time == 0) {
            clearInterval(timer);
            this.time = 60;
            this.valiText = '获取验证码';
          } else {
            this.valiText = this.time + '秒后重试';
            this.time--;
          }
        }, 1000);
      }
    },
    //打开忘记密码弹框
    openForgetPassword() {
      this.forgetPasswordModel = true;
    },
    //关闭忘记密码弹框
    closeForgetPassword() {
      this.newMobile = null;
      this.securityCode = null;
      this.errorText = '没有绑定手机号码的学生请联系教师或管理员！';
      this.forgetPasswordModel = false;
    },
    //找回密码下一步验证
    nextForgetPassword() {
      if (this.newMobile != null && this.newMobile != '' && this.securityCode != null && this.securityCode != '') {
        this.$http.get('/api/admin/user/nextCodeVerifyCode', { params: { phone: this.newMobile, verifyCode: this.securityCode } }).then(res => {
          if (res.data.flag) {
            //打开修改密码弹框，关闭找回密码弹框
            this.passwordModel = true;
            this.errorText = '密码需包含字母 + 不连续数字组合，且大于6位，小于20位，不可有空格';
            this.forgetPasswordModel = false;
          } else {
            this.errorText = res.data.message;
          }
        })
      } else {
        this.errorText = '手机号和验证码不能为空!';
        return false;
      }
    },
    //关闭修改密码
    closeUpdatePhonePwd() {
      this.newPassword = null;
      this.oldPassword = null;
      this.passwordModel = false;
      this.closeForgetPassword();
    },
    //修改密码确定
    updatePhonePwd(phone) {
      if (this.oldPassword != this.newPassword) {
        this.errorText = '密码不一致请重新输入';
        return false;
      }
      if (this.oldPassword != null && this.newPassword != null) {
        this.$http.get('/api/admin/user/updatePhonePwd', { params: { phone: phone, newPwd: this.newPassword, confirmPwd: this.oldPassword } }).then(res => {
          if (res.data.flag) {
            Toast({
              message: '操作成功',
              iconClass: 'mint-toast-icon mintui mintui-success'
            });
            //关闭修改密码弹框
            this.closeUpdatePhonePwd();
          } else {
            this.errorText = res.data.message;
          }
        })
      } else {
        this.errorText = '密码不能为空';
        return false;
      }
    },
    //关闭绑定手机号弹框
    closeBindingPhoneModel() {
      this.bindingPhoneModel = false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/user/loginStudent.vue